"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const next_components_icon_label_n_1 = __importStar(require("@gerenciatd/next.components.icon-label-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const next_components_button_n_1 = __importStar(require("@gerenciatd/next.components.button-n"));
const utils_1 = require("./utils");
const MoreOptionsContent = ({ options, segment, isPriority, addModal }) => {
    if (!options) {
        return null;
    }
    const handleCloseModal = () => {
        addModal({
            type: 'MODAL',
            id: '',
        });
    };
    const { size: buttonSize, color: buttonColor } = (0, utils_1.getButtonAppearance)(segment);
    return (react_1.default.createElement("div", { className: "MoreOptionsContent" },
        react_1.default.createElement("div", { className: "OptionsContainer" }, options.map((option) => {
            const { kind, link, name, svgId, taggingInfo } = option;
            return (react_1.default.createElement(next_components_custom_link_1.default, { key: name, href: link, forceExternal: true, className: "ItemOption", title: name, ariaLabel: name, taggingInfo: taggingInfo, onClick: handleCloseModal },
                react_1.default.createElement(next_components_icon_label_n_1.default, { id: svgId, iconColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6, labelColor: next_components_icon_label_n_1.ICON_COLOR.GREY_4, iconSize: 28, labelFont: next_components_icon_label_n_1.ICON_LABEL_FONT_TYPE.LIGHT, labelSize: 16, kind: kind, label: name, labelPosition: "right" })));
        })),
        react_1.default.createElement(next_components_button_n_1.default, { label: "Cancelar", onClick: handleCloseModal, backgroundColor: buttonColor, buttonWidth: next_components_button_n_1.BUTTON_WIDTH.FULL, height: next_components_button_n_1.BUTTON_HEIGHT.NORMAL, taggingInfo: {
                componentName: 'Header',
                componentContent: 'cancelar',
                componentVariation: `${options[0].taggingInfo.componentVariation}${isPriority ? '-priority' : ''}`,
                componentProduct: '',
            } })));
};
const mapStateToProps = (state) => ({
    segment: state.main.context.pageSegment,
});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(MoreOptionsContent);
//# sourceMappingURL=index.js.map